import { featureClasses } from './featureClasses';
import { languageLevels } from './languageLevels';
import { personDetails } from './personDetails';
import { personDemoData } from './demoTableData';
import { universities } from './universities';
import { loremIpsum } from './loremIpsum';
import { slateInitialValue } from './slateInitialValue';
import { slateSerializationInitialData } from './slateSerializationInitialData';
import { slateMdSerializationInitialData } from './slateMdSerializationInitialData';
import { workloadItems } from './workload';
import { locations } from './locationsData';

export const demoData = {
    featureClasses,
    languageLevels,
    personDetails,
    personDemoData,
    universities,
    loremIpsum,
    slateInitialValue,
    slateSerializationInitialData,
    slateMdSerializationInitialData,
    workloadItems,
    locations,
};
